import {Component, Input, OnInit} from '@angular/core';
import {DomSanitizer, SafeStyle} from "@angular/platform-browser";

@Component({
  selector: 'app-table-image',
  templateUrl: './table-image.component.html',
  styleUrls: ['./table-image.component.scss']
})
export class TableImageComponent implements OnInit {

  @Input() imageUrl: string = "";
  backgroundImage!: string;
  secureImage!: SafeStyle;

  constructor(private sanitizer: DomSanitizer) {
  }

  ngOnInit() {
    this.backgroundImage = `url('${this.imageUrl}')`;
    this.secureImage = this.sanitizer.bypassSecurityTrustUrl(this.imageUrl);
  }

}
